var map = {
	"./Accessories.png": "f43e",
	"./Accessories_1200x800.png": "9d0b",
	"./Assembling_1200x800.png": "dcd3",
	"./Coating_1200x800.png": "6b86",
	"./Compounding_1200x800.png": "a3c9",
	"./Confectioning.png": "7b5f",
	"./Confectioning_1200x800.png": "ab8c",
	"./Cotton_Harvest.jpg": "6090",
	"./Cotton_harvest_1200x800.png": "dd6a",
	"./Cutting.png": "7fcc",
	"./Cutting_1200x800.png": "e1e5",
	"./Design_Development.png": "9cc6",
	"./Design_and_development_1200x800.png": "9288",
	"./Dyeing.png": "159b",
	"./Dyeing_1200x800.png": "dfbb",
	"./Embroidery.png": "1b10",
	"./Embroidery_1200x800.png": "af66",
	"./Exporting.png": "2433",
	"./Exporting_1200x800.png": "7ede",
	"./Fabric_trading.png": "fbdf",
	"./Fabric_trading_1200x800.png": "e5ad",
	"./Finishing.jpg": "bd0a",
	"./Finishing_1200x800.png": "cb31",
	"./Ginning.png": "95da",
	"./Ginning_1200x800.png": "2c93",
	"./Importing.png": "1a9a",
	"./Importing_1200x800.png": "207e",
	"./Knitting.jpg": "5698",
	"./Knitting_1200x800.png": "74d8",
	"./Labelling.png": "4da6",
	"./Labelling_1200x800.png": "7952",
	"./Laminating_1200x800.png": "7c62",
	"./Man_made_material.png": "2acb",
	"./Man_made_material_1200x800.png": "22bb",
	"./Manufacturing_1200x800.png": "432f",
	"./Material_trading.png": "ee16",
	"./Material_trading_1200x800.png": "b073",
	"./Moulding_1200x800.png": "3583",
	"./Natural_material.png": "1fb6",
	"./Natural_material_1200x800.png": "0d10",
	"./Packing.png": "e19e",
	"./Packing_1200x800.png": "7bc9",
	"./Printing.png": "c855",
	"./Printing_1200x800.png": "160c",
	"./Raw_material_1200x800.png": "f3f1",
	"./Recycled_Material.png": "1704",
	"./Recycled_material_1200x800.png": "6875",
	"./Retailing.png": "6fdf",
	"./Retailing_1200x800.png": "2dfd",
	"./Sewing.png": "31dd",
	"./Sewing_1200x800.png": "2660",
	"./Spinning.png": "82e5",
	"./Spinning_1200x800.png": "939b",
	"./Tanning_1200x800.png": "2a8d",
	"./Transport.png": "5994",
	"./Transport_1200x800.png": "5d78",
	"./Trims.png": "1990",
	"./Trims_1200x800.png": "69fb",
	"./Warehousing.png": "4f08",
	"./Warehousing_1200x800.png": "46b7",
	"./Washing.png": "b314",
	"./Washing_1200x800.png": "500c",
	"./Weaving.png": "3040",
	"./Weaving_1200x800.png": "f449",
	"./Webbing_1200x800.png": "8fe5",
	"./Yarn_trading.png": "576b",
	"./Yarn_trading_1200x800.png": "ef48"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ea6e";